import React from 'react';
import LoveButton from '../item/loveButton/loveButton.js'
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import {utils} from '../../utils'
import {itemActions} from '../../utils'

class FullscreenStoreSliderBottomBar extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    let isStoreGallery = utils.isStoreGallery();

    const {love, current, styleParams, item, isSettings} = this.props;
    this.props.love.showCounter = styleParams.loveCounter;
    var showDownload = styleParams.allowDownload && !current.item.isDemo;
    const shareLeftPosition = showDownload ? (love.count > 0 ? 240 : 220) : (love.count > 0 ? 190 : 170);
    const loveLeftPosition = showDownload ? 170 : 100;
    const shareWrapperStyle = {top: 'initial', 'left': shareLeftPosition};
    const loveButtonStyle = {top: 'initial', 'left': loveLeftPosition, marginTop: -10};
    const loveButtonCounterStyle = {top: 'initial', 'left': (loveLeftPosition + 35), marginTop: -8};
    const downloadButtonStyle = {top: 'initial', 'left': 100};

    var desktopLoveButton = (styleParams.loveButton) ? (
      <LoveButton
        layout="fullscreen"
        device='desktop'
        isSettings={isSettings}
        style={loveButtonStyle}
        counterStyle={loveButtonCounterStyle}
        {...love}
      />
    ): '';

    var fullscreenSocialDownload = (
      <FullscreenSocialDownload
        layout="fullscreen"
        device='desktop'
        current={current}
        styleParams={styleParams}
        style={downloadButtonStyle}
      />
    );

    var shareClassNames = ((utils.isSite() && !this.props.isSettings) ? '' : '')
    var shareIcon = (<i style={shareWrapperStyle} className={"progallery-svg-font-icons-share-store fullscreen-social-share-store" + (shareClassNames)}/>)
    var fullscreenNavbarShare = this.props.styleParams.allowSocial ? (
      utils.isSite() && !this.props.isSettings ? (
        <div style={shareWrapperStyle}
          className={"fullscreen-icon fullscreen-social-share-box" + (showDownload ? '' : ' pull-left') + (isStoreGallery ? ' store' : '')}>
          {shareIcon}
          <FullscreenShareButtons item={this.props.current.item}/>
        </div>
      ) : (
        <div style={shareWrapperStyle}
          className={"show-tooltip fullscreen-icon fullscreen-social-share-box" + (showDownload ? '' : ' pull-left') + (isStoreGallery ? ' store' : '')}
          onMouseOver={(e) => itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor')}
          onMouseOut={() => itemActions.hideTooltip()}>
          {shareIcon}
        </div>
      )
    ) : '';

    var desktopSocialBar = (utils.isSmallScreen() || this.props.window.expanded) ? '' :
      (
        <div className={"fullscreen-social"}>
          <div>
            {fullscreenSocialDownload}
            {desktopLoveButton}
            {fullscreenNavbarShare}
          </div>
        </div>
      );

    return (
      <div>
        {desktopSocialBar}
      </div>
    );
  }
}

export default FullscreenStoreSliderBottomBar;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenStoreSliderBottomBar.js